import {
  ComponentRef,
  Injectable,
  Type,
  ViewContainerRef,
} from '@angular/core';
import { NotificationComponent } from '@app/layout/notification/notification.component';
import { Subscription } from 'rxjs';
import { NotificationTypes } from '../notification-types';
import { MessageNotificationComponent } from '@app/layout/notifications/message-notification/message-notification.component';
import { Image } from '@app/entities/images/interfaces/image';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private notificationComponentContainerRef?: ViewContainerRef;

  set notificationContainer(container: ViewContainerRef) {
    this.notificationComponentContainerRef = container;
  }

  private notificationComponentRef:
    | ComponentRef<NotificationComponent>
    | undefined;

  private sub?: Subscription;

  private notificationAppearanceTimeout: any;
  private notificationHideTimeout: any;

  displaySuccessNotification(
    title: string,
    message: string,
    image?: Image,
  ): void {
    this.displayNotification(MessageNotificationComponent, {
      type: NotificationTypes.SUCCESS,
      title,
      message,
      image,
    });
  }

  displayErrorNotification(title: string, message: string): void {
    this.displayNotification(MessageNotificationComponent, {
      type: NotificationTypes.ERROR,
      title,
      message,
    });
  }

  // Display the notification with dynamic content
  private displayNotification(
    contentComponent: Type<any>,
    contentComponentProps?: any,
  ): void {
    if (!this.notificationComponentContainerRef) {
      return;
    }

    clearTimeout(this.notificationAppearanceTimeout);

    // If there is an active component, destroy it immediately (no animation)
    if (this.notificationComponentRef) {
      this.destroyNotification(); // Destroy the old component without animation
    }

    // Create the NotificationComponent dynamically
    this.notificationComponentRef =
      this.notificationComponentContainerRef.createComponent(
        NotificationComponent,
      );

    const contentComponentRef =
      this.notificationComponentRef?.instance.viewContainerRef.createComponent(
        contentComponent,
      );

    if (contentComponentProps) {
      Object.assign(contentComponentRef.instance, contentComponentProps);
    }

    // Listen for the close event emitted by NotificationComponent
    this.sub =
      this.notificationComponentRef.instance.closeNotification.subscribe(() => {
        this.hideNotification();
      });

    this.notificationAppearanceTimeout = setTimeout(() => {
      this.hideNotification();
    }, 3500);
  }

  // Hide and remove the notification (destroy the component)
  hideNotification(): void {
    if (this.notificationComponentRef) {
      this.notificationComponentRef.instance.visible = false;
      this.notificationComponentRef.changeDetectorRef.detectChanges();
      this.notificationHideTimeout = setTimeout(() => {
        this.destroyNotification();
      }, 300);
    }
  }

  private destroyNotification(): void {
    if (this.notificationComponentRef) {
      clearTimeout(this.notificationHideTimeout);
      // Immediately destroy the component (without animation)
      this.notificationComponentRef.destroy();
      this.notificationComponentRef = undefined;

      if (this.sub) {
        this.sub.unsubscribe();
      }
    }
  }
}
